// ─── Malawi Delivery Zones ────────────────────────────────────────────────────
// Districts ordered by priority, then alphabetically.
// Each district has delivery options (pickup points or delivery types).

export const DELIVERY_ZONES = [
  {
    id: "lilongwe",
    name: "Lilongwe",
    options: [
      {
        id: "area18_collection",
        label: "Collection — Area 18",
      },
      {
        id: "courier",
        label: "Courier Collection",
        subOptions: [
          { id: "smart_town",  label: "Smart Deliveries — Town", fee: 0 },
          { id: "cts_town",    label: "CTS — Town",              fee: 0 },
          { id: "speed_town",  label: "Speed — Town",            fee: 0 },
          { id: "area49_cts",  label: "Area 49 CTS",             fee: 0 },
          { id: "thanki_cts",  label: "Thanki CTS",              fee: 0 },
          { id: "area25_cts",  label: "Area 25 CTS",             fee: 0 },
          { id: "area23_cts",  label: "Area 23 CTS",             fee: 0 },
        ],
      },
      {
        id: "door",
        label: "Door to Door",
        subOptions: [
          { id: "area18",       label: "Area 18",      fee: 5000  },
          { id: "area14",       label: "Area 14",      fee: 5000  },
          { id: "area43",       label: "Area 43",      fee: 5000  },
          { id: "area10",       label: "Area 10",      fee: 5000  },
          { id: "area6",        label: "Area 6",       fee: 5000  },
          { id: "area30",       label: "Area 30",      fee: 5000  },
          { id: "area47",       label: "Area 47",      fee: 5000  },
          { id: "area49",       label: "Area 49",      fee: 5000  },
          { id: "area25",       label: "Area 25",      fee: 12000 },
          { id: "area9",        label: "Area 9",       fee: 5000  },
          { id: "capital_hill", label: "Capital Hill", fee: 5000  },
          { id: "city_centre",  label: "City Centre",  fee: 5000  },
          { id: "area15",       label: "Area 15",      fee: 5000  },
          { id: "other",        label: "Other area",   fee: 10000 },
        ],
      },
    ],
  },
  {
    id: "blantyre",
    name: "Blantyre",
    options: [
      { id: "town",        label: "Town" },
      { id: "limbe",       label: "Limbe" },
      { id: "kudya",       label: "Kudya" },
      { id: "chilomoni",   label: "Chilomoni" },
      { id: "kamedza",     label: "Kamedza" },
    ],
  },
  {
    id: "zomba",
    name: "Zomba",
    options: [
      { id: "town",        label: "Town" },
      { id: "matawale",     label: "Matawale" },
    ],
  },
  {
    id: "mzuzu",
    name: "Mzuzu",
    options: [
      { id: "town",        label: "Town" },
      { id: "luwinga",        label: "Luwinga" },
    ],
  },
  { id: "balaka",       name: "Balaka",       options: [{ id: "office", label: "Office Collection" }] },
  { id: "chikwawa",     name: "Chikwawa",     options: [{ id: "office", label: "Office Collection" }] },
  { id: "chiradzulu",   name: "Chiradzulu",   options: [{ id: "office", label: "Office Collection" }] },
  { id: "chitipa",      name: "Chitipa",      options: [{ id: "office", label: "Office Collection" }] },
  { id: "dedza",        name: "Dedza",        options: [{ id: "office", label: "Office Collection" }] },
  { id: "dowa",         name: "Dowa",         options: [{ id: "office", label: "Office Collection" }] },
  { id: "karonga",      name: "Karonga",      options: [{ id: "office", label: "Office Collection" }] },
  { id: "kasungu",      name: "Kasungu",      options: [{ id: "office", label: "Office Collection" }] },
  { id: "likoma",       name: "Likoma",       options: [{ id: "office", label: "Office Collection" }] },
  { id: "machinga",     name: "Machinga",     options: [{ id: "office", label: "Office Collection" }] },
  { id: "mangochi",     name: "Mangochi",     options: [{ id: "office", label: "Office Collection" }] },
  { id: "mchinji",      name: "Mchinji",      options: [{ id: "office", label: "Office Collection" }] },
  { id: "mkhotakhota",  name: "Mkhotakhota",  options: [{ id: "office", label: "Office Collection" }] },
  { id: "mwanza",       name: "Mwanza",       options: [{ id: "office", label: "Office Collection" }] },
  { id: "mwanza",       name: "Mwanza",       options: [{ id: "office", label: "Office Collection" }] },
  { id: "nkhatabay",    name: "Nkhata Bay",   options: [{ id: "office", label: "Office Collection" }] },
  { id: "nkhotakota",   name: "Nkhotakota",   options: [{ id: "office", label: "Office Collection" }] },
  { id: "nsanje",       name: "Nsanje",       options: [{ id: "office", label: "Office Collection" }] },
  { id: "ntcheu",       name: "Ntcheu",       options: [{ id: "office", label: "Office Collection" }] },
  { id: "ntchisi",      name: "Ntchisi",      options: [{ id: "office", label: "Office Collection" }] },
  { id: "phalombe",     name: "Phalombe",     options: [{ id: "office", label: "Office Collection" }] },
  { id: "rumphi",       name: "Rumphi",       options: [{ id: "office", label: "Office Collection" }] },
  { id: "salima",       name: "Salima",       options: [{ id: "office", label: "Office Collection" }] },
  { id: "thyolo",       name: "Thyolo",       options: [{ id: "office", label: "Office Collection" }] },
  { id: "mulanje",      name: "Mulanje",      options: [{ id: "office", label: "Office Collection" }] },
];
